module.exports = require('./escapeDOMId')
